import * as R from 'ramda';
// import * as types from './types';
import * as types from '../types';
import { BookingService } from '../../services/booking-service';
import { SET_MAIN_NAV_ACTIVE } from '../../../../store/app/types';
import { HttpClient, createHttpGetOptions, MHTTPCL } from '../../../../services/http/http-client';
import { FileService } from '../../../../dt-plugins/file-uploader/file.service';
import { ArtistService, ArtistDetailsRequests } from '../../services/artists';
import { REQUEST_CANCELLED } from '../../../../services/http/error-handler';
import { HttpLib } from '../../../../services/http/http-lib';
import { MODIFICATION_URL } from '../../../../services/common-urls';
import { getNavTabModule } from '../../../../dt-plugins/sidewindow/nav-tab';
import router from '../../../../router';
import { setMainNavInactive } from '../../../../store/app/mutations';

let artistDetailsTokenSource, cancelToken;

const NavTabModule = getNavTabModule(types.ArtistDetails, 'artistDetails');
const artist_idr = () => router.currentRoute.params.artist_id;

export const artistActions = {
  async [types.ARTISTS.FETCH.ALL]({ commit }) {
    const artistResponse = await BookingService.findAllArtists();
    console.log(artistResponse);
    commit(types.ARTISTS.SET.ALL, artistResponse.data.all_artist);
    commit(types.SET_USERS, artistResponse.data.users);
  },
  async [types.SET_ARTIST_DETAILS]({ commit }, { flag, artist }) {
    commit(types.SET_ARTIST_DETAILS, flag);
    commit(types.SELECTED_ARTIST.SET.SINGLE, artist);
    commit(SET_MAIN_NAV_ACTIVE, !flag, { root: true });


    if (flag) {
      const artistId = artist.artist_id;

      // const artistOverview = await BookingService.findArtistOverview({
      //   artistId: artist.artist_id
      // });

      // commit(types.SET_SELECTED_ARTIST_DATA, {
      //   artistOverview: artistOverview.data
      // });

      console.time('Details Requests');

      if (artistDetailsTokenSource) {
        artistDetailsTokenSource.cancel(REQUEST_CANCELLED);
      }
      // console.log(HttpLib);
      artistDetailsTokenSource = HttpLib.CancelToken.source();
      cancelToken = artistDetailsTokenSource.token;

      commit(types.SET_SELECTED_ARTIST_DATA, null);

      const selectedArtistData = await ArtistDetailsRequests({
        artistId
      }, createHttpGetOptions({
        cancelToken
      }));

      // const responses = await Promise.all(tabRequests);


      commit(types.SET_SELECTED_ARTIST_DATA, selectedArtistData);
      console.log(selectedArtistData);
      console.timeEnd('Details Requests');

    }
  },
  async [types.UPDATE_SELECTED_ARTIST_DATA]({ commit, dispatch, getters }, payload) {    
    // commit(types.UPDATE_SELECTED_ARTIST_DATA, payload);  // It should commented after fully moved to Nav Tab architecture of Booking->Artist module.

    const { artist_id, ...rest } = payload;
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const artistID = artist_id ?? artist_idr();
    NavTabHelper.updateSingleNavTabDetails(artistID, artistDetailsObj => {
      return {
        ...artistDetailsObj,
        ...rest
      };
    });
  },
  async [types.RELATED_CONTACTS.UPDATE.SINGLE]({ commit, getters, dispatch }, payload) {
    const { selectedArtistData, item, name, value } = payload;
    // console.log('mdsir kVal', selectedArtistData);

    const key =
      ['relation', 'contract_flag', 'travel_flag'].includes(name) ? 'contact_relation_id' :
        ['passport_no', 'birthdate', 'phone1'].includes(name) ? 'contact_id' : 'contact_id';

    const table =
      key === 'contact_relation_id' ? 'contact_relations' :
        key === 'contact_id' ? 'contacts' : 'contacts';

    const kVal = item[key];
    if (!kVal) {
      return;
    }


    // const contactRelations = getters.selectedArtistData.contactRelations.map(e => {
    //   if (e[key] === kVal) {
    //     return {
    //       ...e,
    //       [name]: value
    //     };
    //   } else {
    //     return e;
    //   }
    // });

    // commit(types.RELATED_CONTACTS.SET.SINGLE, contactRelations); 

    const contactRelations = selectedArtistData.contact_relations.map(e => {
      if (e[key] === kVal) {
        return {
          ...e,
          [name]: value
        };
      } else {
        return e;
      }
    });

    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(selectedArtistData?.artist?.artist_id, artistDetailsObj => {
      return {
        contact_relations: [
          ...contactRelations
        ]
      };
    });

    const updatedContactRelation = await BookingService.modifyRelatedContact({
      key,
      kVal,
      name,
      value,
      table
    });

  },
  async [types.ArtistExternalLinks.SET.ALL]({ commit, dispatch }, {artist_id, external_links}) {
    // commit(types.ArtistExternalLinks.SET.ALL, payload);
    dispatch(types.UPDATE_SELECTED_ARTIST_DATA, {
      external_links,
      artist_id
    });
  },
  async [types.RELATED_CONTACTS.SET.ALL]({ commit, dispatch }, {
    contact_relations,
  }) {
    // commit(types.RELATED_CONTACTS.SET.SINGLE, contact_relations);
    dispatch(types.UPDATE_SELECTED_ARTIST_DATA, { contact_relations });
  },
  async [types.RELATED_CONTACTS.DELETE.SINGLE]({ commit, getters, dispatch }, { contactRelationId, selectedArtistData }) {
    // console.log(getters, getters.selectedArtistData.contactRelations);
    const contactRelations = selectedArtistData.contact_relations.filter(contactRelation => {
      if (contactRelation.contact_relation_id === contactRelationId) {
        return false;
      } else {
        return true;
      }
    });

    // commit(types.RELATED_CONTACTS.SET.SINGLE, contactRelations);

    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(selectedArtistData?.artist?.artist_id, artistDetailsObj => {
      return {
        contact_relations: [
          ...contactRelations
        ]
      };
    });

    const deletedContactRelation = await ArtistService.deleteContactRelation({ contactRelationId });
  },
  async [types.SELECTED_ARTIST.UPDATE.SINGLE]({ commit, getters }, payload) {
    const { item, name, value } = payload;

    // Different update process for main_contact_id


    const key =
      [
        'notes',
        'main_contact_id',
        'url1',
        'url2',
        'url3',
        'cost_center',
        'default_agent_commission'
      ].includes(name) ? 'artist_id' : 'artist_id';

    const kVal = item[key];

    if (!kVal) {
      return;
    }


    const table =
      ['artist_id'].includes(key) ? 'booking_artists' : 'booking_artists';

    if (['main_contact_id'].includes(name)) {
      commit(types.SELECTED_ARTIST.SET.SINGLE, {
        ...getters.selectedArtist,
        [name]: value
      });

      const insertedMainContactId = await BookingService.setMainContactId({
        contactId: value,
        artistId: kVal
      });

      return;
    }

    console.log(getters.selectedArtist, name, value);

    commit(types.SELECTED_ARTIST.SET.SINGLE, {
      ...getters.selectedArtist,
      [name]: value
    });

    const updatedSelectedArtist = await HttpClient.modify(
      key,
      kVal,
      name,
      value,
      table
    );


    // Updatring the Artist List - By the individual Artist Data Update
    commit(types.ARTISTS.SET.ALL, getters.artists.map(a => {
      if (a.artist_id == kVal) {
        return {
          ...a,
          [name]: value
        };
      } else {
        return a;
      }
    }));

  },
  async [types.UPLOAD_ARTIST_CUSTOM_DATA]({ commit, getters, dispatch }, payload) {
    const { name, value, item, edit } = payload;
    const { artist_id } = item;
    console.log("payload", payload);
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    if (edit) {
      // commit(types.UPDATE_SELECTED_ARTIST_DATA,
      //   {
      //     artist_custom_data: getters.selectedArtistData.customData.map(e => {
      //       if (e.custom_data_id == name) {
      //         return {
      //           ...e,
      //           data: value
      //         };
      //       }
      //       return e;
      //     })
      //   });
        
      NavTabHelper.updateSingleNavTabDetails(artist_id, artistDetailsObj => {
        const artist_custom_data = artistDetailsObj.artist_custom_data.map(e => {
          if (e.custom_data_id == name) {
            return {
              ...e,
              data: value
            };
          }
          return e;
        });

        return {
          artist_custom_data
        };
      });

      await ArtistService.modifyCustomData({
        name, value
      });
    } else {
      const FieldArray = await ArtistService.findArtistCustomData(artist_id);
      // console.log("CUSTOM FIELD", FieldArray);
      // commit(types.UPDATE_SELECTED_ARTIST_DATA,
      //   {
      //     artist_custom_data: FieldArray.data.artist_custom_data
      //   });

      dispatch(types.UPDATE_SELECTED_ARTIST_DATA, {
        artist_custom_data: FieldArray.data.artist_custom_data,
        artist_id
      });
    }


  },
  async [types.ARTIST_FILES.UPDATE.ALL]({ commit, dispatch, getters }, { files, externalId, externalTable }) {
    // commit(types.ARTIST_FILES.SET.ALL, files);

    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    const artist_id = externalId;
    NavTabHelper.setSingleNavTabDetails(
      artist_id,
      (_, artistDetailsObj) => {
        return {
          ...artistDetailsObj,
          files
        };
      }
    );
  },
  async [types.ARTIST_FILES.DELETE.SINGLE]({ commit }, file) {
    console.log(file.item);
    const deletedFile = await FileService.deleteFile({
      fileId: file.item.file_id,
      fileRelatoinId: file.item.file_relation_id,
    });
    commit(types.ARTIST_FILES.DELETE.SINGLE, file.item);

  },
  async [types.ARTIST_RELATED_INFO.DELETE.SINGLE]({ commit }, payload) {
    const { artistInfoId } = payload;
    commit(types.ARTIST_RELATED_INFO.DELETE.SINGLE, { artistInfoId });
    const deletedRelatedInfo = await ArtistService.deleteRelatedInfo({
      artistInfoId
    });
  },
  async [types.ARTIST_RELATED_USER.DELETE.SINGLE]({ commit, getters, dispatch }, payload) {

    // const { artistId, userId } = payload;

    // commit(types.ARTIST_RELATED_USER.SET.ALL, getters.selectedArtistData.relatedUsers.filter(user => {
    //   if (user.user_id == userId) {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // }));

    
    const { userId, selectedArtistData:{ artist, related_users } } = payload;
    const ru = related_users.filter(user => {
      if (user.user_id == userId) {
        return false;
      } else {
        return true;
      }
    });   

    dispatch(types.UPDATE_SELECTED_ARTIST_DATA, {
      related_users: ru,
      artist_id: artist.artist_id
    });

    const deletedAgent = await ArtistService.removeUserFromArtist({artistId: artist.artist_id, userId});
  },
  async [types.ARTIST_RELATED_USER.INSERT.MULTIPLE]({ commit, getters, dispatch }, {users, artist_id}) {
    // commit(types.ARTIST_RELATED_USER.SET.ALL, [
    //   ...getters.selectedArtistData.relatedUsers,
    //   ...users
    // ]);
    
    // console.log(getters.selectedArtistData.relatedUsers, {
    //   artistId: getters.selectedArtist.artist_id,
    //   userIds: users.map(e => e.user_id).join(',')
    // });

    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(artist_id, artistDetailsObj => {
      return {
        related_users: [
          ...artistDetailsObj.related_users,
          ...users
        ]
      };
    });

    await ArtistService.addUserToArtist({
      artistId: artist_id,
      users
    });
  },
  async [types.ARTIST_RELATED_COUNTRIES.DELETE.SINGLE]({ commit, dispatch }, payload) {
    ArtistService.removeCountry(payload);
    // commit(types.ARTIST_RELATED_COUNTRIES.DELETE.SINGLE, payload);

    const { artistCountryId, selectedArtistData:{ artist, related_countries } } = payload;
    const rc = related_countries.filter(relatedCountry => {
      if (relatedCountry.artist_country_id === artistCountryId) {
        return false;
      } else {
        return true;
      }
    });

    dispatch(types.UPDATE_SELECTED_ARTIST_DATA, {
      related_countries: rc,
      artist_id: artist.artist_id
    });
  },
  async [types.ADD_ARTIST_CUSTOM_DATA]({ commit, getters }, payload) {
    console.log(payload);
    const { fieldLabel } = payload;
    const addedField = await ArtistService.insertCustomData({
      fieldLabel
    });
    const artistCustomData = await ArtistService.findArtistCustomData({
      artistId: getters.selectedArtist.artist_id
    });
    console.log(artistCustomData);
    commit(types.UPDATE_SELECTED_ARTIST_DATA,
      {
        artist_custom_data: artistCustomData.data.artist_custom_data
      }
    );
  },
  async [types.SET_ARTIST_CUSTOM_DATA]({ commit, getters }, payload) {
    commit(types.SET_ARTIST_CUSTOM_DATA, payload);
  },
  async [types.FILTER_ARTIST_BOOKING_LIST]({ commit, dispatch }, payload) {
    const {
      artistId,
      month,
      location,
      city,
      partner,
      promoter
    } = payload;

    console.log({
      month,
      location,
      city,
      partner,
      promoter
    });
    if (
      Object.values({
        month,
        location,
        city,
        partner,
        promoter
      }).filter(e => e).length === 0
    ) {
      const bookingList = await ArtistService.findArtistBookings({
        artistId
      });

      dispatch(types.UPDATE_SELECTED_ARTIST_DATA, {
        bookings: bookingList.data.bookings,
        artist_id: artistId
      });
    } else {

      const filteredList = await ArtistService.filterArtistBookingList(payload);

      dispatch(types.UPDATE_SELECTED_ARTIST_DATA, {
        bookings: filteredList.data.bookings,
        artist_id: artistId
      });
    }
  },
  async [types.NEXT_ARTIST_BOOKINGS]({ commit, dispatch, getters }, payload) {
      const nextList = await ArtistService.findNextArtistBookings(payload);
      const selectedArtist = getters.artistDetails[artist_idr()];

      dispatch(types.UPDATE_SELECTED_ARTIST_DATA, {
        bookings: [...selectedArtist.bookings, ...nextList.data.bookings]
      });
    
  },
  async [types.ADD_TRACK]({ commit, dispatch }, payload) {
    const { artistId } = payload;
    const artistAdded = await ArtistService.addTrack({
      artistId
    });

    console.log(artistAdded);
    dispatch(types.UPDATE_SELECTED_ARTIST_DATA, {
      tracks: artistAdded.data.tracks
    });
  },
  async [types.SEARCH_ARTIST]({ commit, dispatch }, payload) {
    const searchString = payload;
    if (!searchString) {
      dispatch(types.ARTISTS.FETCH.ALL);
      return;
    }
    const searchResult = await ArtistService.searchArtist({
      searchString
    });
    // console.log(searchResult.data.all_artist);
    commit(types.ARTISTS.SET.ALL, searchResult.data.all_artist);
  },
  async [types.FILTER_ARTIST_BY_USER]({ commit, dispatch }, payload) {
    const { userId } = payload;
    if (!userId) {
      dispatch(types.ARTISTS.FETCH.ALL);
      return;
    }
    const searchResult = await ArtistService.filterArtistByUser({
      userId
    });
    // console.log(searchResult.data.all_artist);
    commit(types.ARTISTS.SET.ALL, searchResult.data.all_artist);
  },
  async [types.CREATE_ARTIST]({ commit, dispatch }, payload) {
    const createdArtist = await ArtistService.createArtist(payload);
    console.log(createdArtist);
    dispatch(types.ARTISTS.FETCH.ALL);
  },
  async [types.DELETE_ARTIST]({ commit, dispatch }, payload) {
    const { artistId } = payload;
    console.log(payload);
    commit(types.ARTISTS.DELETE.SINGLE, payload);
    const deletedArtist = await ArtistService.deleteArtist({
      artistId
    });
    dispatch(types.ARTISTS.FETCH.ALL);
  },
  ...NavTabModule.implementActions(
    'artist_id',
    'artists/artist_id/tab',
    'artists',
    () => router,
    'booking',
    (value, key) => {
      console.log("value::mdsir:", value)
      return {
        title: value?.artist?.artist_name ? value?.artist?.artist_name : key,
        full_title: value?.artist?.artist_name ? value?.artist?.artist_name : key
      }
    }
  ),

  // Show Sidewindow
  async [types.ArtistDetails.FETCH.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    let { flag, artist, reload } = payload;

    flag = typeof flag === "boolean" ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = "artist_id";
    const itemName = "artist";
    const item = payload[itemName];

    if (!item) {
      return;
    }

    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = "artistDetails";
    const DetailsAction = types.ArtistDetails;

    // Check Reload and prexisting Item Logic
    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }

    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
        [itemName]: item,
        loading: true
      };
    });

    // HTTP Req
    const selectedArtistData = await ArtistDetailsRequests({
      artistId : artist.artist_id
    }, createHttpGetOptions({
      cancelToken
    }));

    NavTabHelper.setSingleNavTabDetails(
      primaryKeyValue,
      (detailsDict, artist) => {
        return {
          ...artist,
          ...selectedArtistData,
          loading: false,
        };
      }
    );
  },
  
  async [types.ArtistDetails.UPDATE.SINGLE](
    { commit, getters, dispatch },
    payload
  ) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    
    const { item, name, value } = payload;

    // Different update process for main_contact_id

    const key =
      [
        'notes',
        'main_contact_id',
        'url1',
        'url2',
        'url3',
        'cost_center',
        'default_agent_commission'
      ].includes(name) ? 'artist_id' : 'artist_id';

    const kVal = item[key];

    if (!kVal) {
      return;
    }


    const table =
      ['artist_id'].includes(key) ? 'booking_artists' : 'booking_artists';

    if (['main_contact_id'].includes(name)) {

      NavTabHelper.updateSingleNavTabDetails(kVal, artistDetailsObj => {
        console.log('artistDetailsObj', artistDetailsObj)
        return {
          artist: {
            ...artistDetailsObj.artist,
            [name]: value
          }
        };
      });

      const insertedMainContactId = await BookingService.setMainContactId({
        contactId: value,
        artistId: kVal
      });

      return;
    }

    // console.log(getters.selectedArtist, name, value);

    NavTabHelper.updateSingleNavTabDetails(kVal, artistDetailsObj => {
      console.log('artistDetailsObj', artistDetailsObj)
      return {
        artist: {
          ...artistDetailsObj.artist,
          [name]: value
        }
      };
    });

    const updatedSelectedArtist = await HttpClient.modify(
      key,
      kVal,
      name,
      value,
      table
    );


    // Updatring the Artist List - By the individual Artist Data Update
    commit(types.ARTISTS.SET.ALL, getters.artists.map(a => {
      if (a.artist_id == kVal) {
        return {
          ...a,
          [name]: value
        };
      } else {
        return a;
      }
    }));


  },
  
  async [types.ArtistDetailMap.FETCH.MULTIPLE]({ dispatch }, payload) {
    const artistMapData = await ArtistService.findArtistMap(payload);
    dispatch(types.UPDATE_SELECTED_ARTIST_DATA, { ...artistMapData.data });
  },

}

